module.exports = __webpack_public_path__ + "static/media/glass.d011ae3a.png";